import React from 'react'
import './continueenabled.css'
import { Button } from 'react-bootstrap'

function ContinueEnabled({onContinue, disabled, label = 'Continue'}) {
  return (
    <div className='btn-wrapper'>
        <button
            className='continue-btn'
            onClick={onContinue}
            disabled={disabled}
            style={disabled ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
        >
            {disabled ? 'Please wait...' : label}
        </button>
    </div>
  )
}

export default ContinueEnabled